import { useParams, useSearchParams } from 'react-router-dom';

import useLinkAfterCreate from 'src/Components/EntityLinks/hooks/useLinkAfterCreate';
import { ProjectForm } from 'src/Components/Forms/Project/ProjectForm';
import { useCreateProjectForm } from 'src/Hooks/Forms/useCreateProjectForm';
import useCreateProject from 'src/Hooks/Mutations/useCreateProject';
import { LinkableEntityType } from 'src/Services/API/EntityLinks.api';
import { CreateProjectDto, CreateProjectDtoStatusEnum } from 'src/Services/API/generated/api';

import { Props } from './ProjectCreationFormWrapper.types';

const ProjectCreationFormWrapper = ({ onClose }: Props) => {
  const { assetId } = useParams<{ assetId: string }>();
  const [searchParams] = useSearchParams();
  const { mutate: createProject, isLoading } = useCreateProject(assetId!);
  const { handleCreated } = useLinkAfterCreate(LinkableEntityType.Project);

  const statusParam = searchParams.get('status') as CreateProjectDtoStatusEnum | null;
  const initialStatus =
    statusParam && Object.values(CreateProjectDtoStatusEnum).includes(statusParam)
      ? statusParam
      : undefined;

  const { form } = useCreateProjectForm({ initialStatus });

  const handleSubmit = (values: CreateProjectDto) => {
    createProject(values, {
      onSuccess: response => handleCreated(response.data.id, onClose),
    });
  };

  return (
    <ProjectForm
      form={form}
      onSubmit={form.onSubmit(handleSubmit)}
      onCancel={onClose}
      isLoading={isLoading}
    />
  );
};

export default ProjectCreationFormWrapper;
